import React, { useState, MouseEvent, useEffect } from 'react';
import { Box, Typography, Divider, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import useStyles from './styles';

export type Field = {
  serialNumber: string; softwarePartNumber: string; hardwarePartNumber: string; synchClockProtocolSupportedFlag: boolean; actingMasterECMFlag: boolean;
};

const EcmDetails = ({ ecmData }: { ecmData: any }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  return (
    <Grid className={classes.margin}>
      <Box p={2} >
        <Typography variant="h5" p={1} className={classes.sectionTitleTypography}>
          ECM Inforamtion:
        </Typography>
        <Divider />
        {ecmData && ecmData.length === 0 && <p>No ECM Information available.</p>}
        {ecmData && ecmData.length > 0 && ecmData.map((item: Field, index: any) =>
          <>
            <Box p={1} pb={1} display="flex" className={classes.attribute}>
              <Typography className={classes.titleTypography}>
                ECM{index + 1}:
              </Typography>
            </Box>
            <Box p={1} mr={5} pb={1} display="flex" className={classes.attribute}>
              <Typography variant="h6" className={classes.titleTypography}>
                ECM S/N:
              </Typography>
              <Typography>{item.serialNumber ? `${item.serialNumber}` : '-'}</Typography>
            </Box>
            <Box p={1} mr={5} pb={1} display="flex" className={classes.attribute}>
              <Typography variant="h6" className={classes.titleTypography}>
                Software P/N:
              </Typography>
              <Typography>  {item.softwarePartNumber ? `${item.softwarePartNumber}` : '-'}</Typography>
            </Box>
            <Box p={1} mr={5} pb={1} display="flex" className={classes.attribute}>
              <Typography variant="h6" className={classes.titleTypography}>
                Hardware P/N:
              </Typography>
              <Typography>  {item.hardwarePartNumber ? `${item.hardwarePartNumber}` : '-'}</Typography>
            </Box>
            <Box p={1} mr={5} pb={1} display="flex" className={classes.attribute}>
              <Typography variant="h6" className={classes.titleTypography}>
                Sync Clock Enabled:
              </Typography>
              <Typography> {item.synchClockProtocolSupportedFlag !== null ? (item.synchClockProtocolSupportedFlag === true ? 'Yes' : 'No') : '-'}</Typography>
            </Box>
            <Box p={1} mr={5} pb={1} display="flex" className={classes.attribute}>
              <Typography variant="h6" className={classes.titleTypography}>
                Sync Clock Level:
              </Typography>
              <Typography> {item.actingMasterECMFlag !== null ? (item.actingMasterECMFlag === true ? 'Master' : 'Not Master') : '-'}</Typography>
            </Box>
          </>
        )
        }
      </Box>
    </Grid>
  );
};

export default EcmDetails;
